import { Moment } from 'moment'

import { BaseModel } from './base.model'
import { ExamSectionResult } from './exam-section-result.model'

export class ExamResult extends BaseModel<ExamResult> {
  static DEFAULT_ATTRIBUTES = {
    sections: new Array<ExamSectionResult>()
  }

  completedAt: Moment
  grade: number
  id: number
  passed: boolean
  sections: ExamSectionResult[]
  sessionId: number
  startedAt: Moment

  isCompleted(): boolean {
    return !!this.completedAt
  }

  isPassed(): boolean {
    return this.passed
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./app/models/exam-result.model.ts